import type { ReactNode } from 'react'
import { cx } from '@shared/lib/cx'
import { actions, description, iconTile, iconTileDanger, root, title } from './EmptyState.css'

export type EmptyStateProps = {
  icon: ReactNode
  title: string
  description?: string
  action?: ReactNode
  tone?: 'default' | 'danger'
  'data-testid'?: string
}

export function EmptyState({
  icon,
  title: titleText,
  description: descriptionText,
  action,
  tone = 'default',
  'data-testid': testId,
}: EmptyStateProps) {
  return (
    <div className={root} data-testid={testId}>
      <span className={cx(iconTile, tone === 'danger' && iconTileDanger)}>{icon}</span>
      <span className={title}>{titleText}</span>
      {descriptionText ? <span className={description}>{descriptionText}</span> : null}
      {action ? <div className={actions}>{action}</div> : null}
    </div>
  )
}
